import { selectNodeChildren } from '@octopus-do/octopus-project-core'
import cx from 'classnames'
import type React from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import css from './ChildrenCorner.module.scss'

type Props = {
  id: string
  parentId: string | null
}

const Corner: React.FC<Props> = ({ id, parentId }) => {
  const childIds = useSelector(selectNodeChildren(parentId || ''), shallowEqual)

  const isFirst = childIds[0] === id
  const isLast = childIds[childIds.length - 1] === id

  if (childIds.length === 1) {
    return null
  }

  if (isFirst) {
    return (
      <div data-tree-connector className={cx(css.container, css.first)}>
        <div className={cx(css.corner, css.right)} />
      </div>
    )
  }

  if (isLast) {
    return (
      <div data-tree-connector className={cx(css.container, css.last)}>
        <div className={cx(css.corner, css.left)} />
      </div>
    )
  }

  return (
    <div data-tree-connector className={cx(css.container)}>
      <div className={cx(css.corner, css.straight)} />
    </div>
  )
}

export default Corner
